__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-scout/v4_1_4/";